<template>
  <!-- http://www.dropzonejs.com/#configuration-options -->
  <div :class="cssclass">
    <div class="form-group">
      <label>{{ text }}</label>

      <vue-dropzone
        ref="myvuedropzone"
        id="dropzone"
        :class="classzone"
        :options="dropzoneOptions"
        :style="
          'min-height:' +
          (this.options.thumbnailHeight != undefined
            ? this.options.thumbnailHeight + 36
            : 150 + 36) +
          'px; text-align:center'
        "
      ></vue-dropzone>

      <b-modal
        v-if="modalInfo.popup"
        ref="modal"
        id="documentModal"
        modal-class="modal"
        ok-only
        size="lg"
        v-model="modalInfo.popup"
        ok-title="Fermer"
      >
        <div slot="modal-header">
          <h1>
            <div slot="modal-title">
              <i class="fas fa-file"></i>
              Informations du document/image
            </div>
          </h1>
        </div>

        <volcan-card-tabs :data="tabs" />
        <volcan-card-content class="tab-content">
          <div
            v-if="tabs.content.content.active && fileSelected"
            class="content-modal"
          >
            <div class="row" v-if="$languages.length > 1">
              <volcan-input-checkbox
                v-model="fileSelected.syncResources"
                text="Textes identiques pour chacune des langues"
                class="col-12"
              />
            </div>

            <div class="row" v-if="!singleFile">
              <volcan-input-checkbox
                :disabled="fileSelected.isPrincipal"
                v-model="fileSelected.isPrincipal"
                text="Document principal"
                class="col-12"
                v-if="isAuthorizeSeo()"
              />
            </div>

            <div
              v-for="(resource, index) in fileSelected.resources"
              v-bind:key="index"
              v-if="
                fileSelected.syncResources
                  ? resource.languageId == getCulture($i18n.locale()).id
                  : resource.languageId == tabs.languageIdActive
              "
            >
              <div
                v-if="resource.save"
                class="alert alert-warning pointer alert-restaure"
                role="alert"
                @click="restaureResInfo(resource)"
              >
                Cliquer ici pour récupérer votre dernière sauvegarde avant la
                synchronisation.
              </div>

              <div class="row" v-if="hasInfos">
                <volcan-input-text
                  v-model="resource.name"
                  :id="`name`"
                  text="Texte alternatif (alt)"
                  class="col-12"
                />
              </div>

              <div class="row" v-if="hasInfos && hasLink">
                <volcan-input-text
                  v-model="resource.link"
                  :id="`lien`"
                  text="Lien"
                  class="col-12"
                />
              </div>

              <div class="row" v-if="hasDualUpload">
                <volcan-dropzone
                  :ref="'myvuedropzoneres' + resource.languageId"
                  :functionReplacementState="changeReplacementState"
                  :parentGuid="fileSelected.guid"
                  :refParentDropzone="$refs.myvuedropzone.dropzone"
                  :isResource="true"
                  :resourceInfo="resource"
                  :options="{
                    maxFiles: 1,
                    acceptedFiles: options.acceptedFiles,
                  }"
                  :modalParent="modalInfo"
                  text="Téléversement simple"
                  class="col-12"
                />
              </div>
            </div>
          </div>
        </volcan-card-content>
      </b-modal>
    </div>
  </div>
</template>
<script>
import modal from "@mixins/modal.js";
import languages from "@mixins/languages.js";
import compte from "@mixins/compte.js";
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-dropzone",
  mixins: [modal, languages, compte, helpers],
  props: {
    modalParent: {},
    value: {},
    text: {},
    options: {},
    classzone: {},
    cssclass: {},
    isResource: {},
    resourceInfo: {},
    refParentDropzone: {},
    parentGuid: {},
    functionReplacementState: {},
    isSeo: {
      default: false,
      type: Boolean,
    },
    hasInfos: {
      default: true,
      type: Boolean,
    },
    hasLink: {
      default: false,
      type: Boolean,
    },
    hasDualUpload: {
      default: false,
      type: Boolean,
    },
  },
  data: function () {
    return {
      test: false,
      tabs: {
        languageIdActive: 0,
        content: {
          content: {
            title: "content",
            active: true,
            hasLanguage: true,
          },
        },
      },
      refreshData: false,
      replacementState: false,
      fileSelected: null,
      singleFile: false,
      addOptionsFunction: false,
      dropzoneOptions: {
        previewTemplate: this.template(),
        url: "/api/media/uploadfiles/",
        maxFilesize: 50,
        dictRemoveFile: "",
        dictDefaultMessage: "Déposez l'image à téléverser ici.",
        dictFallbackMessage:
          "Votre navigateur ne supporte pas la fonction \"drag'n'drop\"",
        dictFileTooBig:
          "Le fichier est trop gros ({{filesize}} Mo). Taille de fichier maximale: {{maxFilesize}} Mo.",
        dictInvalidFileType:
          "Vous ne pouvez pas télécharger de fichiers de ce type.",
        dictCancelUpload: "Annuler",
        dictCancelUploadConfirmation:
          "Êtes-vous sûr de vouloir annuler ce téléchargement?",
        dictRemoveFile: "Supprimer",
        dictMaxFilesExceeded:
          "Vous ne pouvez pas télécharger plus de fichiers.",
      },
    };
  },
  watch: {
    "fileSelected.syncResources"(val) {
      this.tabs.content.content.hasLanguage = !val;
      var resCopy = {};
      var resToGet = [];
      if (val) {
        this.tabs.languageIdActive = this.getCulture(this.$i18n.locale()).id;
      }
      this.fileSelected.resources.forEach((res) => {
        if (res.languageId == this.getCulture(this.$i18n.locale()).id) {
          resCopy = res;
        } else {
          resToGet.push(res);
        }
      });

      if (
        val &&
        (resCopy.path != resToGet.path ||
          resCopy.name != resToGet.name ||
          resCopy.link != resToGet.link)
      ) {
        resToGet.forEach((res) => {
          res.save = {
            path: res.path,
            name: res.name,
            link: res.link,
          };

          res.path = resCopy.path;
          res.name = resCopy.name;
          res.link = resCopy.link;
        });
      }
    },
    "fileSelected.isPrincipal"(val) {
      if (!this.singleFile && val) {
        this.value.forEach((element) => {
          element.isPrincipal = false;
        });
        this.fileSelected.isPrincipal = val;
      }
    },
    fileSelected: {
      handler: function (val, oldVal) {
        if (val.syncResources && this.tabs.languageIdActive != 0) {
          var resKeep = val.resources.filter((res) => {
            return res.languageId == this.tabs.languageIdActive;
          })[0];

          var resCopy = val.resources.filter((res) => {
            return res.languageId != this.tabs.languageIdActive;
          });

          resCopy.forEach((res) => {
            res.name = resKeep.name;
            res.link = resKeep.link;
            res.path = resKeep.path;
          });
        }
      },
      deep: true,
    },
    $loading(val) {
      if (!val) {
        this.refreshData = true;
        this.$refs.myvuedropzone.dropzone.removeAllFiles();
        // this.beforeMountFunction()
        this.filldropzone();
      }
    },
    "modalInfo.popup"(val) {
      if (!val) {
        this.tabs.languageIdActive = this.getCulture(this.$i18n.locale()).id;
      }
    },
  },
  beforeMount() {
    this.beforeMountFunction();
  },
  mounted() {
    this.mountedfunction();
  },
  beforeDestroy() {
    this.$refs.myvuedropzone.dropzone.off("removedfile");
  },
  computed: {
    showModal() {
      return this.hasInfos || this.hasDualUpload;
    },
    getFileSelectedResource() {
      let langId = this.fileSelected.syncResources
        ? this.getCulture($i18n.locale()).id
        : this.tabs.languageIdActive;
      this.getResWithLangId(this.fileSelected, langId);
    },
  },
  methods: {
    mountedfunction() {
      this.setEventListener();
      this.filldropzone();
    },
    beforeMountFunction() {
      if (this.options != undefined && this.options != null) {
        jQuery.extend(this.dropzoneOptions, this.options);
        this.addOptionsFunction = true;
      }

      if (!this.singleFile && !this.value) {
        this.$emit("input", null);
      }
    },
    changeEvent() {
      document
        .getElementsByClassName("detail")[0]
        .dispatchEvent(new CustomEvent("change"));
    },
    restaureResInfo(res) {
      res.name = res.save.name;
      res.link = res.save.link;
      res.path = res.save.path;
      res.save = null;

      var dropzone = this.$refs["myvuedropzoneres" + res.languageId][0].$refs[
        "myvuedropzone"
      ].dropzone;
      dropzone.removeAllFiles();

      this.setObjPushDropzone(res, this.parentGuid, dropzone);
    },
    setEventListener() {
      if (this.addOptionsFunction) {
        if (
          this.options.maxFiles != undefined &&
          this.options.maxFiles != null &&
          this.options.maxFiles <= 1
        ) {
          this.singleFile = true;
          this.replaceFileWhenSingle();
        }

        this.maxFileExeededRemoveFile();
      }
      this.sendingMethod();
      this.sucessMethod();
      this.removedfile();
    },
    addClickEvent(file, isParentChange) {
      file.previewElement.addEventListener("click", (e) => {
        if (
          isParentChange == undefined &&
          (this.isResource || !this.showModal)
        ) {
          return;
        }

        this.fileSelected = null;
        if (this.singleFile) {
          this.fileSelected = this.value;
        } else {
          this.fileSelected = this.getModelFile(file.guid);
        }

        if (isParentChange) {
          this.modalParent.popup = true;
        } else {
          this.modalInfo.popup = true;
        }
      });

      var elem = $(file.previewElement).find(`[data-dz-download]`)[0];
      elem.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    },
    addPathDownload(file, data) {
      var elem = $(file.previewElement).find(`[data-dz-download]`)[0];
      $(elem).attr("href", "/" + data.path);
    },
    getModelFile(guid) {
      var files = this.value.filter((obj) => {
        return obj.guid == guid;
      });

      if (files.length > 0) {
        return files[0];
      }
    },
    sendingMethod() {
      this.$refs.myvuedropzone.dropzone.on("sending", (file, xhr, formData) => {
        formData.append("isResource", this.isResource || false);
      });
    },
    sucessMethod() {
      this.$refs.myvuedropzone.dropzone.on("success", (file) => {
        this.changeEvent();

        var data = JSON.parse(file.xhr.response).data;

        file.guid = data.guid;
        file.path = data.path;

        this.imageForFile(file, file.name.split(".").pop());

        if (this.$refs.myvuedropzone.dropzone.files.length <= 1) {
          data.isPrincipal = true;
        }

        if (this.isResource && !this.isSeo) {
          this.resourceInfo.path = data.path;
          this.addPathDownload(file, this.resourceInfo);

          if (
            this.resourceInfo.languageId ==
            this.getCulture(this.$i18n.locale()).id
          ) {
            this.replaceParentFile();
          }
        } else {
          if (data.path == undefined || data.path == "") {
            data.path = data.resources.filter((res) => {
              return res.languageId == this.getCulture(this.$i18n.locale()).id;
            })[0].path;
          }

          this.addPathDownload(file, data);
          if (this.singleFile) {
            this.$emit("input", data);
          } else {
            this.value.push(data);
          }
        }
      });
    },
    replaceParentFile() {
      this.functionReplacementState();
      var parentFile = this.refParentDropzone.files.filter((obj) => {
        return obj.guid == this.parentGuid;
      })[0];

      this.refParentDropzone.removeFile(parentFile);

      this.setObjPushDropzone(
        this.resourceInfo,
        this.parentGuid,
        this.refParentDropzone,
        true
      );
    },
    replaceFileWhenSingle() {
      var self = this;
      this.$refs.myvuedropzone.dropzone.on("addedfile", function (file) {
        if (this.files.length > 1) {
          this.removeFile(this.files[0]);
        }
        self.imageForFile(file, file.name.split(".").pop());
        //self.addPathDownload(file)
      });
    },
    imageForFile(file, ext, isParentChange) {
      if (ext == "pdf") {
        $(file.previewElement)
          .find(".dz-image img")
          .attr("src", "/static/img/pdf.png");
      } else if (ext.indexOf("xls") != -1 || ext.indexOf("xls") != -1) {
        $(file.previewElement)
          .find(".dz-image img")
          .attr("src", "/static/img/excel.png");
      }

      this.addClickEvent(file, isParentChange);
    },
    maxFileExeededRemoveFile() {
      this.$refs.myvuedropzone.dropzone.on("maxfilesexceeded", function (file) {
        this.removeFile(file);
      });
    },
    changeReplacementState() {
      this.replacementState = true;
    },
    removedfile() {
      this.$refs.myvuedropzone.dropzone.on("removedfile", (file) => {
        this.changeEvent();
        if (this.replacementState) {
          this.replacementState = false;
          return;
        }

        if (this.singleFile) {
          if (!this.refreshData) {
            this.$emit("input", null);
          }
        } else {
          var data = this.value.filter((obj) => {
            return obj.guid != file.guid;
          });
          if (!this.refreshData) {
            this.$emit("input", data);
          }
        }
      });
    },
    filldropzone() {
      if (this.singleFile) {
        var info = null;
        if (this.value && this.value.resources) {
          info = this.value.resources.filter((obj) => {
            return obj.languageId == this.getCulture(this.$i18n.locale()).id;
          })[0];
          this.setObjPushDropzone(info, this.value.guid);
        } else if (this.resourceInfo) {
          info = this.resourceInfo;
          this.setObjPushDropzone(info, this.resourceInfo.guid);
        } else if (this.isSeo) {
          info = this.value;
          this.setObjPushDropzone(info, 0);
        }
      } else {
        if (this.value) {
          this.value.forEach((element) => {
            this.setObjPushDropzone(
              element.resources.filter((obj) => {
                return (
                  obj.languageId == this.getCulture(this.$i18n.locale()).id
                );
              })[0],
              element.guid
            );
          });
        }
      }
      this.$isModified = false;
      this.refreshData = false;
    },
    setObjPushDropzone(
      info,
      guid,
      dropzone = this.$refs.myvuedropzone.dropzone,
      isParentChange
    ) {
      if (info) {
        var obj = {
          id: 0,
          guid: guid,
          path: info.path,
          name: info.name,
          link: info.link,
          fileName: info.fileName,
        };

        obj.dataURL = this.$domainPath + obj.path;

        this.pushMediaDropzone(obj, dropzone, isParentChange);
      }
    },
    pushMediaDropzone(obj, dropzone, isParentChange) {
      dropzone.files.push(obj);
      dropzone.emit("addedfile", obj);
      var ext = obj.path.split(".").pop();
      if (["png", "jpg", "jpeg", "gif"].indexOf(ext) >= 0) {
        dropzone.createThumbnailFromUrl(
          obj,
          dropzone.options.thumbnailWidth,
          dropzone.options.thumbnailHeight,
          dropzone.options.thumbnailMethod,
          true,
          (thumbnail) => {
            dropzone.emit("thumbnail", obj, thumbnail);
          },
          "anonymous"
        );
      }
      this.imageForFile(obj, ext, isParentChange);
      this.addPathDownload(obj, obj);
      dropzone.emit("complete", obj);
    },
    template() {
      var styleHeight =
        "height:" +
        (this.options.thumbnailHeight != undefined
          ? this.options.thumbnailHeight
          : "150") +
        "px;";
      var styleWidth =
        "width:" +
        (this.options.thumbnailWidth != undefined
          ? this.options.thumbnailWidth
          : "150") +
        "px";

      if (
        this.options.thumbnailHeight == undefined ||
        (this.options.thumbnailWidth >= 150 &&
          this.options.thumbnailHeight >= 150)
      ) {
        var infotext = "";

        if (!this.isResource && this.showModal) {
          infotext = `<div class="dz-details">
                          <div class="thumbnail-info"><span>Informations</span></div>
                      </div>`;
        }

        return `<div class="dz-preview dz-file-preview" style="${
          styleHeight + styleWidth
        }">
          <div class="dz-image">
            <img data-dz-thumbnail />
          </div>
          ${infotext}
          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress style="width: 100%;></span></div>
          <div class="dz-success-mark"><i class="file-icon file-success fa fa-check-circle"></i></div>
          <div class="dz-error-message big-error-message"><span data-dz-errormessage></span></div>
          <div class="dz-error-mark">
            <i class="file-icon file-error fa fa-exclamation-circle"></i>
          </div>
            <a class="file-download fas fa-download file-download-big" data-dz-download target="_blank" ></a>
            <i class="remove-icon fa fa-times-circle file-close" data-dz-remove></i>
          </div>`;
      } else {
        var infotext = "";
        if (this.showModal) {
          infotext = `</div>
                        <div class="dz-details">
                      </div>`;
        }
        return `<div class="dz-preview dz-preview-small dz-file-preview" style="${
          styleHeight + styleWidth
        }">
          <div class="dz-image">
          <img data-dz-thumbnail />
          ${infotext}
          <div class="dz-progress dz-progress-small"><span class="dz-upload" data-dz-uploadprogress></span></div>
          <div class="dz-success-mark"><i class="small-sucess fa fa-check-circle"></i></div>
          <div class="dz-error-message small-error-message"><span data-dz-errormessage></span></div>
          <div class="dz-error-mark">
            <i class="file-icon-small file-error fa fa-exclamation-circle"></i>
          </div>
            <a class="file-download fas fa-download file-download-small" data-dz-download target="_blank"></a>
            <i class="remove-icon fa fa-times-circle file-close-small" data-dz-remove></i>
          </div>`;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../../Shared/Layout/Assets/sass/base/_variables.scss";

.dropzone {
  -webkit-border-radius: 2px !important;
  border-radius: 2px !important;
  border: 2px dashed $primaryColor !important;
  padding: 8px !important;
}

.dropzone .dz-preview {
  z-index: 0 !important;
  margin: 8px !important;
  min-height: 0 !important;
}

.vue-dropzone .dz-preview .dz-remove {
  margin-left: 16px !important;
}

.file-icon {
  font-size: 65px !important;
  text-align: center !important;
  width: 100% !important;
}

.file-icon-small {
  font-size: 22px !important;
  text-align: center !important;
  width: 100% !important;
}

.vue-dropzone .dz-preview .dz-error-message:after {
  display: none !important;
}

.dropzone .dz-preview .dz-error-message {
  border-radius: 0 !important;
}

.dropzone .dz-preview-small .dz-image {
  position: initial !important;
}

.vue-dropzone .dz-preview .dz-error-message .big-error-message {
  top: calc(20%) !important;
}

.vue-dropzone .dz-preview .dz-details {
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer !important;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 0;
}

.thumbnail-info {
  text-align: center;
  position: relative;
  top: 25%;
  font-size: 18px;
  span {
    cursor: pointer !important;
  }
}

.small-error-message {
  top: calc(35%) !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  left: 0 !important;
  width: auto !important;
}

.file-close {
  cursor: pointer !important;
  font-size: 25px !important;
  top: 0 !important;
  position: absolute !important;
  right: 0 !important;
  z-index: 999 !important;
  margin: 5px !important;
}

.file-download {
  color: gray !important;
  cursor: pointer !important;
  top: 0 !important;
  position: absolute !important;
  z-index: 999 !important;
  left: 0 !important;
}

.file-download-big {
  font-size: 25px !important;
  left: 0 !important;
  margin: 5px !important;
}

.file-download-small {
  font-size: 18px !important;
  margin: 2px !important;
}

.file-close-small {
  cursor: pointer !important;
  font-size: 18px !important;
  top: 0 !important;
  position: absolute !important;
  right: 0 !important;
  z-index: 999 !important;
  margin: 2px !important;
}

.dz-progress-small {
  height: 10px !important;
  margin-left: 0 !important;
  left: 0 !important;
  margin-top: 0 !important;
  width: 50px !important;
}

.remove-icon {
  cursor: pointer !important;
}

.dropzone .dz-preview.dz-file-preview .dz-details {
  opacity: 0 !important;
}

//MODAL

#documentModal {
  .modal-body .tabs {
    margin: -1rem -1rem 0;
  }

  .modal-header {
    background: $darkblue;
    border: none;
    padding: 12px 20px;
    color: #ffffff;
    font-weight: 500;
    text-transform: uppercase;
    i {
      margin: 0.25em 0.625em 0 0;
    }
  }

  .modal-content {
    overflow: visible;
    border-radius: 1.3rem;
  }
}

.content-modal {
  padding-top: 20px;
}

.alert-restaure {
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/dropzone.vue